module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/image-polaroid.svg?dfd768197adb43970c9ec1781778693a";